import './SavingSaved.css';
import savingIcon from '../../assets/SavingIcon.png';
import cloudIcon from '../../assets/Group 6244.svg';
import { useSelector } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import { Popover } from 'antd';

const SavingSaved = () => {
    const savingData = useSelector((state) => state.editor.savingData);

    const [popoverOpen, setPopoverOpen] = useState(false);
    const buttonRef = useRef(null);

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === 'Escape') setPopoverOpen(false);
        };
        if (popoverOpen) document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [popoverOpen]);

    useEffect(() => {
        // Close popover if saving status changes while open (e.g., start saving)
        if ((savingData?.isSaving !== 'Saved') && popoverOpen) {
            setPopoverOpen(false);
        }
    }, [savingData?.isSaving, popoverOpen]);

    const onClickIcon = () => {
        if (savingData?.isSaving === 'Saved') setPopoverOpen(true);
    };

    const onKeyDownIcon = (e) => {
        if (savingData.isSaving === 'Saved' && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            setPopoverOpen(true);
        }
    };

    // Popover handles outside clicks; keep this for legacy/other behavior

    // We no longer compute the modal position manually; Popover handles placement and viewport checking.

    // If savingData disappears or is empty, keep the popover closed; keep hooks stable
    if (!savingData || !savingData.isSaving) return null;

    return (
        <div className="savingSaved">
            <Popover
                content={
                    <div className="savingSaved__popoverContent">
                        <div className="savingSaved__modalHeader">
                            <div className="savingSaved__modalTitleWrap">
                                <div className="savingSaved__modalIcon" aria-hidden>
                                    <img src={cloudIcon} alt="Saved" className="savingSaved__modalIconImg" />
                                </div>
                                <div>
                                    <h3 className="savingSaved__modalTitle">All changes saved</h3>
                                    {savingData.offlineReady && (
                                        <div className="savingSaved__modalSubtitle">This document is ready for offline use</div>
                                    )}
                                </div>
                            </div>
                            <button className="savingSaved__closeBtn" onClick={() => setPopoverOpen(false)} aria-label="Close">×</button>
                        </div>
                        <div className="savingSaved__modalBody">
                            <div className="savingSaved__infoList">
                                <div className="infoRow">
                                    <div className="infoKey">Status</div>
                                    <div className="infoValue">{savingData.isSaving}</div>
                                </div>
                                {savingData.lastSavedDateTime && (
                                    <div className="infoRow">
                                        <div className="infoKey">Saved at</div>
                                        <div className="infoValue">{savingData.lastSavedDateTime}</div>
                                    </div>
                                )}
                                {savingData.fileSize && (
                                    <div className="infoRow">
                                        <div className="infoKey">File size</div>
                                        <div className="infoValue">{savingData.fileSize}</div>
                                    </div>
                                )}
                                {Object.entries(savingData).map(([key, value]) => {
                                    if (['isSaving', 'lastSavedDateTime', 'fileSize'].includes(key)) return null;
                                    return (
                                        <div className="infoRow" key={key}>
                                            <div className="infoKey">{key}</div>
                                            <div className="infoValue">{String(value)}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                }
                trigger="click"
                placement="right"
                visible={popoverOpen}
                onVisibleChange={setPopoverOpen}
                overlayClassName="savingSaved__popover"
            >
                <button
                    ref={buttonRef}
                    className={`savingSaved__iconBtn ${savingData.isSaving === 'Saved' ? 'clickable' : ''}`}
                    onClick={onClickIcon}
                    onKeyDown={onKeyDownIcon}
                    tabIndex={savingData?.isSaving === 'Saved' ? 0 : -1}
                    aria-label={savingData?.isSaving}
                    aria-expanded={popoverOpen}
                    title={savingData.isSaving}
                >
                    {savingData.isSaving === 'Saving...' ? (
                        <img src={savingIcon} alt={'Saving'} className="savingSaved__icon saving_icon" />
                    ) : (
                        <img src={cloudIcon} alt="Saved" className="savingSaved__icon leftActionIcon" />
                    )}
                </button>
            </Popover>
            <span className="savingSaved__text">{savingData.isSaving}</span>

            {/* Popover handles visibility & placement */}
        </div>
    );
};

export default SavingSaved;
